import { render, staticRenderFns } from "./MarginSalesReport.vue?vue&type=template&id=c5b9fe5c&"
import script from "./MarginSalesReport.vue?vue&type=script&lang=js&"
export * from "./MarginSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports